export enum DeviceType {
  DETECTOR = 'detector',
  DETECTOR_SUPPRESSOR = 'detector_suppressor',
}
